<template>

  <v-container fluid fill-height pa-0>

    <v-layout column fill-height ma-0 pa-0>

      <v-layout fill-height ma-0 pa-0 >

        <v-flex xs12 >

          <v-layout fill-height column  ma-0 pa-0 >
           
            <scroll-area>
              <template slot="header">

                <v-toolbar  dense flat>
                  <v-toolbar-title>
                    <span class="body-2 uppercase">{{ $t('channels') }}</span>
                  </v-toolbar-title>

                  <v-layout fill-height justify-end align-center>

                    <v-tooltip v-if="edit" dark color="secondary" bottom>
                      <v-btn :data-testid="$options.name + 'v-btn' + 'onAdd'" icon flat slot="activator" @click="() => onAdd()">
                        <svg-icon
                          :color="'primary'"
                          :name="'add'"
                          width="20"
                        />
                      </v-btn>
                      <span>{{ $t('add') }}</span>
                    </v-tooltip>

                    <v-tooltip v-if="!edit" dark color="secondary" bottom>
                      <v-btn :data-testid="$options.name + 'v-btn' + 'edit--edit'" icon flat slot="activator" @click="() => {edit = !edit}">
                        <svg-icon
                          :color="'primary'"
                          :name="'edit'"
                          width="20"
                        />
                      </v-btn>
                      <span>{{ $t('edit') }}</span>
                    </v-tooltip>

                    <v-tooltip v-if="edit" dark color="secondary" bottom>
                      <v-btn :data-testid="$options.name + 'v-btn' + 'edit--edit'" icon flat slot="activator"  @click="() => {edit = !edit}">
                        <svg-icon
                          :color="'primary'"
                          :name="'close'"
                          width="20"
                        />
                      </v-btn>
                      <span>{{ $t('close') }}</span>
                    </v-tooltip>

                  </v-layout>

                </v-toolbar>

              </template>

              <template slot="body">

                <v-layout column fill-height justify-start ma-0 pa-0 >

                  <scroll-table
                    :data="getTable"
                    :options="getOptions"
                    :subscribed="true"
                    :headUppercase="false"
                    :translate="true"
                    @select=""
                    @value="(payload)=>onSelect(payload)"
                    @remove=""
                  />

                </v-layout>

              </template>

            </scroll-area>
          </v-layout>

        </v-flex>
        
      </v-layout>

    </v-layout>

    <v-dialog persistent v-model="dialog.open" max-width="1000px" v-if="dialog.open">
      <channel-card
        :data="getDialogData"
        :addMode="getAddMode"
        :connections="getConnections"
        :parentData="getData"
        @update="(payload) => onUpdate(payload)"
        @remove="(payload) => onRemove(payload)"
        @close="() => onDialogClose()"
      />
    </v-dialog>

  </v-container>

</template>

<script lang="ts">
import Vue from 'vue'
import scrollArea from '@/nms/components/partials/scrollarea.vue'
import scrollTable from '@/nms/components/partials/scrolltable.vue'
import ChannelCard from '@/nms/pages/services/сreate-channel-card.vue'
import svgIcon from '@/nms/components/media/svg/static/svg-icon.vue'

// Типы
interface EndpointRef {
  $id?: string
  ref?: string
  namePath?: string[]
  [key: string]: any
}

interface ConnectionRef {
  $id?: string
  id?: string
  name?: string
  cls?: string
  refs?: EndpointRef[]
  brefs?: Array<{ ref?: string; name?: string; port_type?: string; [key: string]: any }>
  points?: EndpointRef[]
  point_a?: Array<{ path: string; obj: EndpointRef }>
  point_b?: Array<{ path: string; obj: EndpointRef }>
  services?: string[]
  [key: string]: any
}

interface ChannelItem {
  $id?: string
  id?: string
  name?: string
  template?: string
  refs?: ConnectionRef[]
  connections?: ConnectionRef[]
  connectionsNames?: string[]
  [key: string]: any
}

interface DialogState {
  open: boolean
  addMode: boolean
  data: any | null
}

interface TableColumn {
  title: string
  value: string
  type: string
  width: string
}

interface TableData {
  columns: TableColumn[]
  rows: ChannelItem[]
}

interface OptionsColumns {
  [key: string]: { width: string }
}

interface OptionsData {
  columns: OptionsColumns
}

interface ChannelsData {
  $id?: string
  [key: string]: any
}

export default Vue.extend({
  name: 'CHANNELS',

  components: {
    scrollArea,
    scrollTable,
    ChannelCard,
    svgIcon
  },

  props: {
    data: {
      type: Object as () => ChannelsData,
      default: () => ({})
    },
  },

  data(): {
    dialog: DialogState
    edit: boolean
    show: boolean
    groupUse: boolean
    model: Record<string, any>
    channels: ChannelItem[]
    connections: ConnectionRef[]
    options: OptionsData
    search: string
    table: TableData
  } {
    return {
      dialog: {
        open: false,
        addMode: false,
        data: null,
      },
      edit: false,
      show: false,
      groupUse: false,
      model: {},
      channels: [],
      connections: [],
      options: {
        columns: {
          text: { width: '40%' },
          timestamp: { width: '40%' },
          actions: { width: '40%' },
          check: { width: '20%' },
          check_dependence: { width: '5%' },
        },
      },
      search: '',
      table: {
        columns: [],
        rows: [],
      },
    }
  },

  computed: {
    getData(): ChannelsData {
      return this.data
    },
    getDialogData(): any | null {
      return this.dialog.data
    },
    getAddMode(): boolean {
      return this.dialog.addMode
    },
    getTable(): TableData {
      const t = this.$merge({}, this.table) as TableData
      if (this.search.length) {
        const searchLower = this.search.toLowerCase()
        t.rows = t.rows.filter(row => {
          return row.name?.toLowerCase().indexOf(searchLower) > -1
        })
        return t
      }
      return this.table
    },
    getOptions(): OptionsData {
      return this.options
    },
    getConnections(): ConnectionRef[] {
      return this.connections
    },
  },

  created(): void {
    this.setup()
  },

  methods: {
    async setup(): Promise<void> {
      console.log('CHANNELS', 'loadChannels', 'getData', this.getData)
      await this.loadChannels()
      await this.loadConnections()
    },

    async loadChannels(): Promise<void> {
      console.log('CHANNELS', 'loadChannels', 'START')
      if (!this.getData.$id) return
      
      try {
        const query = {
          id: ['/logical/channel'],
          data: {
            children: {
              data: {
                children: true,
                namePath: true,
                refs: {
                  data: {
                    namePath: true,
                    path: true,
                    refs: {
                      data: { namePath: true, path: true }
                    },
                  }
                },
                brefs: {
                  data: { namePath: true, path: true }
                },
              },
              refs: true
            },
            refs: true
          }
        }
        
        const channels = await this.$bridge.cmdbQuery(query)
        if (channels?.[0]?.children) {
          this.channels = channels[0].children
        }

        console.log('CHANNELS', 'loadChannels', 'channels', this.channels)

        if (this.channels?.length) {
          this.prepareColumns()
        }
      } catch (error) {
        console.error('CHANNELS', 'loadChannels smth wrong', error)
      }
    },

    async loadConnections(): Promise<void> {
      console.log('CHANNELS', 'loadConnections', 'START')
      if (!this.getData.$id) return
      
      try {
        const query = {
          id: [
            {
              fnc: 'getObjectConnections',
              data: { id: this.getData.$id }
            }
          ],
          notNull: true,
          namePath: true,
          data: {
            parent: false,
            namePath: true,
            refs: {
              data: { namePath: true, path: true }
            },
            brefs: {
              data: { namePath: true, path: true }
            },
          }
        }
        
        const connections = await this.$bridge.cmdbQuery(query)
        if (connections?.[0]) {
          console.log('CHANNELS', 'loadConnections', 'connections', connections)
          this.connections = connections
        }
      } catch (error) {
        console.error('CHANNELS', 'loadConnections smth wrong', error)
      }
    },

    async prepareColumns(): Promise<void> {
      this.table = {
        columns: [
          {
            title: 'name',
            value: 'name',
            type: 'text',
            width: '20%'
          },
          {
            title: 'type',
            value: 'template',
            type: 'text',
            width: '10%'
          },
          {
            title: 'connections',
            value: 'connectionsNames',
            type: 'array',
            width: '30%'
          },
        ],
        rows: []
      }
      this.prepareRows()
    },

    async prepareRows(): Promise<void> {
      this.table.rows = this.channels.map(channel => {
        if (channel.refs?.length) {
          channel.connections = []
          channel.connectionsNames = []
          
          channel.refs.forEach(ref => {
            if (ref.cls === 'connection') {
              channel.connectionsNames?.push(ref.name || '')
              channel.connections?.push(ref)

              if (ref.refs?.length) {
                ref.points = []
                ref.refs.forEach(ref$ => {
                  if (ref$.ref === 'endpoint') {
                    ref.points?.push(ref$)
                  }
                })
                
                if (ref.points?.length) {
                  const point = ref.points[0].namePath
                  ref.point_a = [{
                    path: point?.slice(10) || '',
                    obj: ref.points[0]
                  }]
                  
                  if (ref.points[1]) {
                    const point = ref.points[1].namePath
                    ref.point_b = [{
                      path: point?.slice(10) || '',
                      obj: ref.points[1]
                    }]
                  }
                }
              }

              if (ref.brefs?.length) {
                ref.services = []
                ref.brefs.forEach(bref => {
                  if (bref.ref === 'connection') {
                    ref.services?.push(`${bref.name} (${bref.port_type})`)
                  }
                })
              }
            }
          })
        }
        return channel
      })
      
      this.statusSubscribe(this.channels, 'CHANNELS')
      console.log('CHANNELS', 'prepareRows', 'table', this.table)
      console.log('CHANNELS', 'prepareRows', 'this.connections', this.connections)
    },

    async statusSubscribe(arr: any[], group: string): Promise<void> {
      try {
        this.$store.dispatch('measuresSubscribeInit', {
          name: 'addStatus',
          group: 'CHANNELS',
          listener: 'status'
        })
        
        if (arr.length) {
          arr.forEach(item => {
            if (item.$id) {
              this.$store.dispatch('addStatusKey', item)
            }
          })
          await this.$bridge.subscribe(arr.map(obj => obj.$id))
        }
      } catch (error) {
        console.error('CHANNELS', 'statusSubscribe', 'error', error)
      }
    },

    subscribeHandler(e: { $id?: string; [key: string]: any }): void {
      if (e.$id) {
        this.$store.dispatch('addStatus', e)
      }
    },

    statusUnsubscribe(): void {
      this.$store.dispatch('measuresSubscribeClose', {
        handler: this.subscribeHandler,
        group: 'CHANNELS',
        listener: 'status'
      })
    },

    onAdd(): void {
      console.log('CHANNELS', 'onAdd')
      this.$set(this.dialog, 'addMode', true)
      this.$set(this.dialog, 'open', true)
    },

    onSelect(val: ChannelItem): void {
      console.log('CHANNELS', 'onSelect', 'val', val)
      if (val) {
        this.$set(this.dialog, 'data', val)
        this.$set(this.dialog, 'addMode', false)
        this.$set(this.dialog, 'open', true)
      }
    },

    onDialogClose(): void {
      console.log('CHANNELS', 'onDialogClose')
      this.$set(this.dialog, 'data', null)
      this.$set(this.dialog, 'addMode', false)
      this.$set(this.dialog, 'open', false)
    },

    async onUpdate(val: ChannelItem): Promise<void> {
      console.log('CHANNELS', 'onUpdate', 'val', val)
      console.log('CHANNELS', 'onUpdate', 'dialogData', this.getDialogData)
      
      if (!val?.$id && !this.getDialogData.$id) {
        this.setup()
        return
      }
      
      try {
        let id = val.$id || this.getDialogData.$id
        const $obj = await this.$bridge.getObjectById(id)
        console.log('CHANNELS', 'onUpdate', 'updated $obj', $obj)
        const c = await $obj.update(val)
        
        if (c) {
          await this.$store.dispatch('updateObject', { $id: c.$id })
          console.log('CHANNELS', 'onUpdate', 'updated update $obj', c)
          this.$bridge.litePolling(c.$id)
          this.setup()
        } else {
          this.$dialog.notify.error(this.$getTranslate('something wrong with connection'), {
            timeout: 3000
          })
          console.log('CHANNELS', 'onUpdate', 'updated update $obj ERROR', c)
        }
      } catch (error) {
        this.$errorHandler(error)
        console.error('CHANNELS', 'onUpdate smth wrong', error)
      }
    },

    async onRemove(val: ChannelItem): Promise<void> {
      console.log('CHANNELS', 'onRemove', 'val', val)
      
      try {
        const obj$ = await this.$bridge.getObjectById(val.$id)
        if (obj$) {
          const d = await obj$.delete()
          if (d) {
            this.onDialogClose()
            this.setup()
            this.$dialog.notify.success('Соединение удалено', { timeout: 5000 })
            this.setup()
          }
        }
      } catch (error) {
        console.error('CHANNELS', 'onRemove smth wrong', error)
        this.$errorHandler(error)
      }
    },

    reset(): void {
      this.dialog = {
        open: false,
        addMode: false,
        data: null,
      }
    },
  },
})
</script>

<style lang="css" scoped>
</style>
